export const genders = [
  { value: "M", label: "Male" },
  { value: "F", label: "Female" },
  { value: "A", label: "Asexual" },
  { value: "P", label: "Prefer not to say" },
  { value: "O", label: "Other" },
] as const;

export type Gender = (typeof genders)[number]["value"];
